import React from 'react'
import { t } from 'ttag'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'

import { loadProfileStats } from '../../actions/profileViewActions'
import { condenseSmall } from '../../actions'
import withRecharts from '../../components/withRecharts'
import { useInitDispatch } from '../../util/hooks'

const ProfileStatsView = ({ stats, dynamicValues, recharts }) => {
  const params = useParams()

  useInitDispatch(loadProfileStats(params.profileType, params.profileId), [
    params.profileType,
    params.profileId
  ])

  if (!stats || Object.keys(stats).length <= 0) {
    return null
  }

  console.log('FOUND STATS', stats)

  const {
    Bar,
    BarChart,
    Cell,
    Pie,
    PieChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
  } = recharts
  const generatePieChart = data => {
    return (
      <ResponsiveContainer aspect={3 / 2} width="100%">
        <PieChart width={300} height={200} isAnimationActive={false}>
          <Pie
            data={condenseSmall(data)}
            label={p => (
              <text {...p} fill="black">
                {p.payload.period}
              </text>
            )}>
            {data.map((_, index) => (
              <Cell
                key={index}
                fill={dynamicValues.plotColors[index % dynamicValues.plotColors.length]}
              />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    )
  }
  const generateBarChart = data => {
    class CustomizedAxisTick extends React.Component {
      render() {
        const { x, y, stroke, payload } = this.props

        return (
          <g transform={`translate(${x},${y})`}>
            <text
              x={0}
              y={0}
              dy={16}
              textAnchor="end"
              fill="#666"
              transform="rotate(-35)">
              {payload.value}
            </text>
          </g>
        )
      }
    }

    return (
      <ResponsiveContainer aspect={16 / 9} width="100%">
        <BarChart
          width={160}
          height={90}
          data={data}
          margin={{ top: 5, right: 30, left: 20, bottom: 25 }}>
          <XAxis dataKey="period" tick={<CustomizedAxisTick />} />
          <YAxis />

          <Bar dataKey="value" fill={dynamicValues.plotColors[0]} />
        </BarChart>
      </ResponsiveContainer>
    )
  }
  const events = events => {
    return (
      <ul className="pastevents">
        {events.map(e => (
          <li>
            <a href={e.url}>{e.name}</a>
          </li>
        ))}
      </ul>
    )
  }

  return (
    <div>
      <div className="row">
        <div className="col-xs-12 col-sm-8">
          <h3>{t`Jobs Search Statistics`}</h3>
          {generateBarChart(stats.jobSearchResults)}
        </div>
        <div className="col-xs-12 col-sm-4">
          <h3>{t`Demographics`}</h3>
          {generatePieChart(stats.logViewDemographics)}
        </div>
      </div>
      <div className="row" style={{ marginTop: '50px' }}>
        <div className="col-xs-12 col-sm-8">
          <h3>{t`Usage Statistics`}</h3>
          {generateBarChart(stats.jobLogRecords)}
        </div>
        <div className="col-xs-12 col-sm-4">
          <h3>{t`Past Events`}</h3>
          {events(stats.events)}
        </div>
      </div>
    </div>
  )
}
const stateToProps = state => {
  return {
    ...state.profileView,
    dynamicValues
  }
}
const dispatchToProps = dispatch => ({})

export default connect(stateToProps, dispatchToProps)(withRecharts(ProfileStatsView))
